import { gql } from '@apollo/client'

export const CHECK_DISCOUNT_CODE = gql`
  query CheckDiscountCode(
    $eventId: String!
    $ticketName: String!
    $code: String!
  ) {
    checkDiscountCode(eventId: $eventId, ticketName: $ticketName, code: $code) {
      type
      success
      discountTitle
      percentage
      amount
    }
  }
`
